export default __webpack_public_path__ + "static/media/ads_ten_left.092f9d63.png";